export const IDVERIFY_OK = 'IDVERIFY_OK' //  IdVerify ok 身份验证全局通讯
